import React, { Component } from 'react';
import * as pt from 'prop-types';
import xtend from 'xtend';

class TranscriptPlayer extends Component {
    constructor (props) {
        super(props);

        this.getId = this.getId.bind(this);
        this.destroyPlayer = this.destroyPlayer.bind(this);
        this.initialize = this.initialize.bind(this);
    }

    componentDidCatch (error, info) {
        console.log('componentDidCatch', error, info);
    }

    componentWillUnmount () {
        this.destroyPlayer();
    }

    componentDidMount () {
        this.initialize();
    }

    initialize () {
        const opts = {
            primary: 'html5',
            hlshtml: true,
            width: '100%',
            aspectratio: '16:9'
        };

        var jw = jwplayer(this.getId());

        if (jw.setup) {
            jw.setup(xtend(opts, {
                sources: [
                    { file: this.props.event.streamingURIs.main },
                    { file: this.props.event.streamingURIs.backup }
                ]
            }));
        }
    }

    getId () {
        return 'transcript-player-' + this.props.eventID;
    }

    destroyPlayer () {
        try {
            jwplayer(this.getId()).remove();
        } catch (e) {
            console.log(e);
        }
    }

    render () {
        return <div id={this.getId()}></div>;
    }
}

TranscriptPlayer.propTypes = {};

export default TranscriptPlayer;
